import { createBrowserRouter, RouterProvider } from "react-router-dom";
import RouteArr from "../configuration/getRoutes";
import Main from "../pages/main";
import { Login } from "../pages";
import Socket from "../pages/socket";
import SocketClient from "../pages/socketclient";
import ForgetPassword from "../pages/forgetpassword";
import ResetPassword from "../pages/resetpassword";
import { SocketProvider } from "../context/SocketContext";
import NotFound from "../pages/notfound/notfound";

const router = createBrowserRouter([
  {
    name: "Login",
    path: "/",
    key: "login",
    route: "/",
    element: <Login />,
  },

  {
    name: "ForgetPassword",
    path: "/forget-password",
    key: "forget-password",
    route: "/forget-password",
    element: <ForgetPassword />,
  },

  {
    name: "ResetPassword",
    path: "/reset-password/:token",
    key: "reset-password/:token",
    route: "/reset-password/:token",
    element: <ResetPassword />,
  },

  {
    name: "socket/driver",
    path: "/socket/driver",
    key: "socket",
    route: "/",
    element: <Socket />,
  },

  {
    name: "socket/client",
    path: "/socket/client",
    key: "socket",
    route: "/",
    element: <SocketClient />,
  },

  {
    path: "/",
    element: (
      <SocketProvider>
        <Main />
      </SocketProvider>
    ),
    children: RouteArr,
  },

  {
    path: "*",
    element: <NotFound />,
  },

]);

const Routes = () => {
  return <RouterProvider router={router} />;
};

export default Routes;
